<template>
  <div >
    <div id="ventana-ajustes">
      <p class="title has-text-centered has-text-white">{{ textoInterfaz.titulo }}</p>

      <div class="columns is-mobile" data-tour="ajustes-toggles">
        <div class="column has-text-right ">
          <p class="title is-6 has-text-white mb-3 pt-2">{{ textoInterfaz.efectoInmersion }}</p>
          <p class="title is-6 has-text-white">{{ textoInterfaz.musicaAmb }}</p>
          <p class="title is-6 has-text-white">{{ textoInterfaz.modoOnLine }}</p>
          <p class="title is-6 has-text-white mt-3">{{ textoInterfaz.tipoDado.label }}</p>
        </div>
        <div class="column has-text-left">
          <div class="buttons has-addons m-0">
            <button :class="{'is-outlined': $store.state.PistasAudio.EfectoInmersion == false }" 
              @click="$store.state.PistasAudio.EfectoInmersion = true" class="button is-success is-small is-selected">ON</button>
            <button :class="{'is-outlined': $store.state.PistasAudio.EfectoInmersion == true }" 
              @click="$store.state.PistasAudio.EfectoInmersion = false" class="button is-danger is-small">OFF</button>
          </div>
          <div class="buttons has-addons m-0">
            <button :class="{'is-outlined': $store.state.PistasAudio.MusicaHambiental == false }" 
              @click="($store.state.PistasAudio.MusicaHambiental = true), switchSoundTrackInPlay(true)" 
              class="button is-success is-small is-selected">ON</button>

            <button :class="{'is-outlined': $store.state.PistasAudio.MusicaHambiental == true }" 
              @click="($store.state.PistasAudio.MusicaHambiental = false), switchSoundTrackInPlay(false)" 
              class="button is-danger is-small">OFF</button>
          </div>
          <div style="display:flex; align-items:center; gap:0.3rem;">
            <div class="buttons has-addons mb-0">
              <button :class="{'is-outlined': $store.state.ModoOnLine == false }"
                @click="reactivarModoOnLine()" class="button is-success is-small is-selected">ON</button>
              <button :class="{'is-outlined': $store.state.ModoOnLine == true }"
                @click="cancelarModoOnLine()" class="button is-danger is-small">OFF</button>
            </div>
            <button
              class="button is-small is-dark poll-btn"
              :disabled="$store.state.ModoOnLine == false"
              :title="$store.state.lenguaje === 'español' ? 'Buscar invitación ahora' : 'Search for invitation now'"
              @click="manualPoll()"
            >
              <span class="icon is-small"><i class="fas fa-satellite-dish"></i></span>
            </button>
          </div>
          <div class="buttons has-addons mt-3">
            <button class="button is-small is-link" @click="modalTipoDado = true">
              {{ textoInterfaz.tipoDado.elegir }} ({{ nombreTipoDadoActual }})
            </button>
          </div>
        </div>
      </div>

      <!-- Modal para elegir el diseño de dado -->
      <div v-if="modalTipoDado" class="modal is-active">
        <div class="modal-background" @click="modalTipoDado = false"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ textoInterfaz.tipoDado.titulo }}</p>
            <button class="delete" @click="modalTipoDado = false"></button>
          </header>
          <section class="modal-card-body">
            <div class="dados-opciones-grid">
              <div v-for="skin in diceSkins" :key="skin.id" class="dado-opcion"
                :class="{ seleccionado: $store.state.tipoDadoSkin === skin.id }"
                :title="skin.nombre[$store.state.lenguaje] || skin.nombre.español"
                :aria-label="skin.nombre[$store.state.lenguaje] || skin.nombre.español"
                @click="$store.state.tipoDadoSkin = skin.id">
                <DiceFloatPreview :skin="skin" />
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- id de Mapa onLine -->
      <div :data-tour="esMapa ? 'ajustes-map-code' : null" v-if="this.$store.state.datosMapa.id">
        <p class="subtitle has-text-white mb-0">{{ textoInterfaz.mapCode }}</p>
        <b-field >
          <b-input placeholder="1234-1234-1234"
              type="search"
              icon="magnify"
              v-model="codeIDMapInPlay">
          </b-input>
          <p class="control">
              <b-button type="is-primary" label="Copiar" @click="copyCode()" />
          </p>
        </b-field>
      </div>

      <!-- boton para guardar perdonaje OnLine -->
       <div data-tour="ajustes-guardar">
        <button @click="safeinvOnLine()" class="button is-fullwidth  is-warning">
          {{ textoInterfaz.botones.safeInv || "💾 Guardar investigador" }}
        </button>
       </div>

    </div>
    
    <footer data-tour="ajustes-footer">
      <button @click="backToSelectInv()" class="button is-fullwidth is-dark mb-2"> <i class="fas fa-users mx-3"></i>{{ textoInterfaz.botones.seleccionPersonaje }} </button>
      <button @click="endGame()" class="button is-fullwidth  is-black"> <i class="fas fa-power-off mx-3"></i>{{ textoInterfaz.botones.terminarPartida }} </button>
    </footer>
  </div>
</template>

<script>
import { invitationService } from '@/services/invitationService.js';
import { apiService } from '@/services/api.js';
import { audioService_effects } from '@/services/GestionAudio/audioService_effects.js';
import { DICE_SKINS, getDiceSkin } from '@/components/inPlay/player/diceRoller/diceSkins.js';
import DiceFloatPreview from '@/components/inPlay/player/diceRoller/DiceFloatPreview.vue';

import { useUser, useAuth } from '@clerk/vue'
import { onMounted } from 'vue'
import { useStore } from 'vuex' // importamos esto para poder usar el store en el setup

//SoundTrack
import { audioService_audioInPlay } from '@/services/GestionAudio/audioService_soundTrack.js';


export default {
  name: "AjustesPlay",
  components: { DiceFloatPreview },
  props: {
    // Este componente se monta a la vez en la pestaña Player y en la pestaña Map (comparten
    // el mismo StoreAjustesPlay). Con esta prop distinguimos la instancia del mapa para que
    // el tour (data-tour="ajustes-map-code") no apunte a la copia oculta de la pestaña Player.
    esMapa: { type: Boolean, default: false },
  },
  data(){
    return{
      audioIniciado: false,
      modalTipoDado: false,
      diceSkins: DICE_SKINS,
      textoInterfaz:{
        titulo: "",
        musicaAmb:"",
        efectoInmersion: "",
        modoOnLine:"",
        mapCode: "",
        botones: {
          seleccionPersonaje: "",
          terminarPartida: ""
        },
        tipoDado: {
          label: "",
          elegir: "",
          titulo: ""
        }
      },
    }
  },
  setup() {

    const { isSignedIn } = useAuth()
    const { user } = useUser()
    const store = useStore()
    // importamos store
    // Exponemos user

    onMounted(async () => {
      if (isSignedIn.value) {
        try {
          const idUser = user.value.id;
          store.commit('setUserHost', idUser);
        } catch (e) {
          console.error('Error al cargar los datos del usuario:', e)
        } 
      }
    })
    return { user }
  },
  methods:{
    SonidoTecla() {audioService_effects.playTecla()},
    switchSoundTrackInPlay(activar) {
      if (activar) {
        audioService_audioInPlay.play();
      } else {
        audioService_audioInPlay.endSoundInPlay();
      }
    },

    backToSelectInv(){
      this.SonidoTecla()
      this.$store.state.ModalConfirmacion = true;
      this.$store.state.Terminarpartida = false
    },

    endGame(){
      this.SonidoTecla()
      this.$store.state.ModalConfirmacion = true;
      this.$store.state.Terminarpartida = true
    },

    rellenarTextoSegunIdioma(){
      if(this.$store.state.lenguaje == 'español'){
        this.textoInterfaz.titulo = "Ajustes";
        this.textoInterfaz.musicaAmb = "Musica Ambiental";
        this.textoInterfaz.efectoInmersion = "Efecto Inmersión";
        this.textoInterfaz.modoOnLine = "Modo OnLine";
        this.textoInterfaz.mapCode = "Codigo de mapa:";
        this.textoInterfaz.botones.seleccionPersonaje = "Volver a selección de personaje";
        this.textoInterfaz.botones.terminarPartida = "Terminar partida";

        this.textoInterfaz.tipoDado.label = "Tipo de dado";
        this.textoInterfaz.tipoDado.elegir = "Elegir";
        this.textoInterfaz.tipoDado.titulo = "Tipo de dado";

      }else if(this.$store.state.lenguaje == 'ingles'){
        this.textoInterfaz.titulo = "Settings";
        this.textoInterfaz.musicaAmb = "Background Music";
        this.textoInterfaz.efectoInmersion = "Immersion Effect";
        this.textoInterfaz.modoOnLine = "OnLine Mode";
        this.textoInterfaz.mapCode = "Map code:";
        this.textoInterfaz.botones.seleccionPersonaje = "Back to character selection";
        this.textoInterfaz.botones.terminarPartida = "End game";

        this.textoInterfaz.tipoDado.label = "Dice type";
        this.textoInterfaz.tipoDado.elegir = "Choose";
        this.textoInterfaz.tipoDado.titulo = "Dice type";
      }
    },
    // Método para copiar el código del mapa al portapapeles
    async copyCode() {
      try {
        await navigator.clipboard.writeText(this.$store.state.datosMapa.id);
        this.$buefy.toast.open({
          message: this.$store.state.lenguaje === "español" ? "Código copiado 😊" : "Code copied 😊",
          type: 'is-success',
          duration: 2000,
        });
      } catch (err) {
        this.$buefy.toast.open({
          message: this.$store.state.lenguaje === "español" ? "Error al copiar 😢" : "Copy failed 😢",
          type: 'is-danger',
          duration: 2000,
        });
      }
    },

    // Método para preparar los datos del investigador con los campos adicionales
    prepareInvestigatorData() {
      // Obtener los datos del investigador actual del store
      const investigatorData = { ...this.$store.state.datosPJactual };
      
      // Añadir idUser si no existe
      if (!investigatorData.idUser) {
        investigatorData.idUser = this.$store.state.IDUserHost;
      }
      
      // Añadir idMapOnLine si no existe, ahoramismo no usamos este dato, pero lo usaremos para enlazar invOnLine con mapaOnLine
      if (!investigatorData.idMapOnLine) {
        investigatorData.idMapOnLine = this.$store.state.datosMapa.id;
      }
      // la idOnLine, si no está, se crea en back y si está, se manda para que back la actualice
      // si el lastUpdate no esta, igual que arriba, se crea en back
      
      return investigatorData;
    },

    // metodo para guardar el investigador
    safeinvOnLine(){
      // 1- vemos si el usuario esta logeado: sino le mandamos mensajito de loguearse
      if (!this.$store.state.IDUserHost) {
        this.$buefy.toast.open({
          message: this.$store.state.lenguaje === "español" ? 
            "Debes estar logueado para guardar tu investigador" : 
            "You must be logged in to save your investigator",
          type: 'is-warning',
          duration: 3000,
        });
        return;
      }

      // Preparar los datos del investigador antes de enviar
      const investigatorData = this.prepareInvestigatorData();

      try {
        // mandamos a guardar a back, el ya se encargará de mirar si la memoria del usuario esta llena o si el investigador ya esta creado
        this.guardarInvestigador(investigatorData);
      } catch (error) {
        console.error("error al guardar el investigador:", error)
      }
    },

    // Método principal para guardar el investigador
    async guardarInvestigador(investigatorData) {
      try {
        
        console.error("se van a guardar estos datos a backend: ", investigatorData)
        const response = await apiService.postInvOnLine(investigatorData);
        console.log("Respuesta del servidor al guardar investigador:", response);
        
        if (response.message) {
          
          this.$buefy.toast.open({
            message: this.$store.state.lenguaje === "español" ? 
              "Investigador guardado correctamente 😊" : 
              "Investigator saved successfully 😊",
            type: 'is-success',
            duration: 3000,
          });
        } else {
          throw new Error('Error en la respuesta del servidor');
        }
      } catch (error) {
        console.error('Error al guardar investigador:', error);
        this.$buefy.toast.open({
          message: this.$store.state.lenguaje === "español" ? 
            "Error al guardar el investigador 😢, limite de 5 investigadores excedido" : 
            "Error saving investigator 😢",
          type: 'is-danger',
          duration: 3000,
        });
      }
    },

    // Cancelar Modo OnLine
    async manualPoll() {
      if (!this.$store.state.ModoOnLine) return
      this.$buefy.toast.open({
        message: this.$store.state.lenguaje === 'español' ? 'Buscando invitaciones...' : 'Searching for invitations...',
        type: 'is-info',
        duration: 1500
      })
      await invitationService.checkInvitations()
    },

    async cancelarModoOnLine(){
      invitationService.stopPollingGeneral();
      this.$store.state.ModoOnLine = false
      let idUser = this.$store.state.IDUserHost;
      let invData = null;
      let idZone = 1;
      let available = false;

      // decimos a back que no estamos disponibles y paramos el polling General
      await apiService.postLocationInMap(idZone , idUser, invData, available );
      this.$buefy.toast.open({
        message: this.$store.state.lenguaje === "español" ? "Modo OnLine OFF" : "OnLine Mode OFF",
        type: 'is-danger',
        duration: 2000,
      });
    },

    // Reractivar Modo OnLine
    async reactivarModoOnLine(){
      invitationService.resumePollingGeneral();;
      this.$store.state.ModoOnLine = true
      this.$buefy.toast.open({
        message: this.$store.state.lenguaje === "español" ? "Modo OnLine ON" : "OnLine Mode ON",
        type: 'is-success',
        duration: 2000,
      });
    }
  },

  computed: {
    codeIDMapInPlay(){
      return this.$store.state.datosMapa.id
    },
    nombreTipoDadoActual(){
      const skin = getDiceSkin(this.$store.state.tipoDadoSkin)
      return skin.nombre[this.$store.state.lenguaje] || skin.nombre.español
    }
  },
  mounted(){
    this.rellenarTextoSegunIdioma();
  }
  //TODO : Añadir metodos para cambiar el estado de la musica y efectos
}
</script>

<style scoped>
#ventana-ajustes{
  height: 40vh;
}
.poll-btn {
  border-radius: 6px !important;
  transition: all 0.2s;
}
.poll-btn:not(:disabled):hover {
  background: #3273dc !important;
  color: #fff !important;
  border-color: #3273dc !important;
}
.poll-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
/* Sin texto, sólo el dado flotando: tarjetas compactas para aprovechar el
   ancho en móvil (caben 4 por fila en vez de 2-3). */
.dados-opciones-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(72px, 1fr));
  gap: 0.5rem;
}
.dado-opcion {
  position: relative;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 0.35rem;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.dado-opcion:hover {
  border-color: rgba(255, 255, 255, 0.4);
}
.dado-opcion.seleccionado {
  border-color: rgba(120, 255, 140, 0.4);
}
/* Resplandor sutil y difuso detrás del dado elegido: un brillo ambiental que
   respira despacio, no un halo marcado ni un efecto de botón */
.dado-opcion.seleccionado::before {
  content: "";
  position: absolute;
  inset: -15%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(120, 255, 140, 0.3) 0%, rgba(120, 255, 140, 0.1) 45%, transparent 75%);
  filter: blur(14px);
  animation: dado-brillo 3.2s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}
.dado-opcion.seleccionado :deep(.dice-float-wrap) {
  position: relative;
  z-index: 1;
}
@keyframes dado-brillo {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.8; }
}
@media (prefers-reduced-motion: reduce) {
  .dado-opcion.seleccionado::before { animation: none; opacity: 0.55; }
}
</style>